{
  "title": "Teams",
  "subtitle": "Organize your members into teams. Projects are linked to a team to restrict access.",
  "new_team": "New team",
  "name_placeholder": "Team name (Marketing, Engineering, etc.)",
  "color": "Color:",
  "cancel": "Cancel",
  "create": "Create",
  "loading": "Loading teams…",
  "empty_title": "No teams yet",
  "empty_subtitle": "Create the first one to group members and restrict projects.",
  "create_first": "Create the first one",
  "members_one": "{n} member",
  "members_other": "{n} members",
  "rename": "Rename",
  "delete": "Delete",
  "favorite_add": "Add to favorites",
  "favorite_remove": "Remove from favorites",
  "favorite_error": "Couldn't update the favorite.",
  "no_members_yet": "No members yet.",
  "view_detail": "View detail",
  "confirm_delete_title": "Delete the team \"{name}\"?",
  "confirm_delete_message": "Its {n} members will be left without a team. Linked projects will become visible to the whole workspace.",
  "confirm_delete_action": "Delete",
  "error_create": "Couldn't create the team.",
  "error_rename": "Couldn't rename.",
  "error_delete": "Couldn't delete."
}
